import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ColumnCategory, DraggableOutputColumn } from '../../../Common/AV-AS/category.column.picker.component';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { TaskSeriesType } from '../../Task.Model';

export interface ActionViewOutputCustomParams {
    fromActionView: boolean;
    taskType: TaskSeriesType;
    systemColumns: DraggableOutputColumn[];
    userColumns: DraggableOutputColumn[];
}

@Component({
    selector: 'action-view-output-custom',
    template: `
        <ws-modal-wrapper
            [headerLabel]="taskTypeName"
            [suppressKeyboardEvents]="true"
            (save)="save()"
            (cancel)="cancel()"
        >
            <category-column-picker
                [disableUseSystemDefined]="params.fromActionView"
                [category]="category"
                cpMode="av"
                [selectedTaskType]="params.taskType"
            />
        </ws-modal-wrapper>
    `,
    standalone: false,
})
export class ActionViewOutputCustomComponent
    implements OnInit, IWeissmanModalComponent<ActionViewOutputCustomParams, DraggableOutputColumn[] | undefined>
{
    constructor(private readonly modalRef: BsModalRef) {}

    params: ActionViewOutputCustomParams;
    result: DraggableOutputColumn[] | undefined;

    taskTypeName: string = '';
    category: ColumnCategory = { columns: [], defaultColumns: [] };

    ngOnInit(): void {
        this.taskTypeName = this.params.taskType.name === 'All' ? 'All Task Types' : this.params.taskType.name;
        const selected = this.params.userColumns.length ? this.params.userColumns : this.params.systemColumns;
        this.category = {
            columns: [...selected]
                .sort((left, right) => left.sequence - right.sequence)
                .map((column) => ({ ...column, isRemovable: true })),
            defaultColumns: this.params.systemColumns.map((column) => ({ ...column })),
        };
    }

    cancel(): void {
        this.result = undefined;
        this.modalRef.hide();
    }

    save(): void {
        if (this.category.columns.length) {
            const selectedIds = this.category.columns.map((column) => this.getColumnId(column)).sort((a, b) => a - b);
            const defaultIds = this.category.defaultColumns
                .map((column) => this.getColumnId(column))
                .sort((a, b) => a - b);
            const usesSystemColumns =
                selectedIds.length === defaultIds.length &&
                selectedIds.every((columnId, index) => columnId === defaultIds[index]);

            if (!usesSystemColumns || this.params.fromActionView) {
                this.result = this.category.columns.map((column, sequence) => ({ ...column, sequence }));
            }
        }
        this.modalRef.hide();
    }

    private getColumnId(column: DraggableOutputColumn): number {
        return column.id ?? column.columnId ?? column.advancedSearchFieldID ?? 0;
    }
}
